import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'footer-total',
  // templateUrl: 'footer-total.html'
  template: require('./footer-total.html'),
  styles: [`
  .footer-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    background-color: #f8f9fa;
}

.footer-item {
  display: flex;
  align-items: center;
  margin: 0 15px 0 0;
}

.footer-key {
  font-weight: bold;
  margin-right: 8px;
  font-size: 12px;
  color: #e9211c !important;
}

.footer-value {
  font-weight: bold;
  color: #e9211c ;
  font-size: 12px;
}

  `]
})
export class FooterTotalComponent implements OnInit {
  @Input() footerData: { key: string, value: any, isVisible:boolean } [ ] = [];
  constructor() { }

  ngOnInit() {
    console.log('FooterTotalComponent');
  }

}